module.exports = __webpack_public_path__ + "img/1.f7c35f67.png";